"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeDefaultCall = exports.encodeBuy = exports.encodeSell = exports.encodeParamsCall = exports.getParams = exports.encodeWeb3Call = exports.encodeCall = exports.encodeReplacementPattern = void 0;
var Abi_1 = require("../utils/Abi");
var ethereumjs_util_1 = require("ethereumjs-util");
var types_1 = require("../utils/types");
var tronweb_1 = __importDefault(require("tronweb"));
var failWith = function (msg) {
    throw "Error";
};
var generateDefaultValue = function (type) {
    switch (type) {
        case 'address':
        case 'bytes20':
            return '0x0000000000000000000000000000000000000000';
        case 'bytes32':
            return '0x0000000000000000000000000000000000000000000000000000000000000000';
        case 'bool':
            return false;
        case 'int':
        case 'uint':
        case 'uint8':
        case 'uint16':
        case 'uint32':
        case 'uint64':
        case 'uint256':
            return 0;
        default:
            throw ('Default value not yet implemented for type: ' + type);
    }
};
var encodeReplacementPatterns = function (abi, kinds, encodeToBytes) {
    var output = [];
    var data = [];
    var dynamicOffset = abi.inputs.reduce(function (len, _a) {
        var type = _a.type;
        var match = type.match(/\[(.+)\]$/);
        return len + (match ? parseInt(match[1], 10) * 32 : 32);
    }, 0);
    abi.inputs
        .map(function (_a) {
        var kind = _a.kind, type = _a.type, value = _a.value;
        return ({
            bitmask: kinds.includes(kind) ? 255 : 0,
            type: (0, Abi_1.elementaryName)(type),
            value: value !== undefined ? value : generateDefaultValue(type)
        });
    })
        .reduce(function (offset, _a) {
        var bitmask = _a.bitmask, type = _a.type, value = _a.value;
        var cur = Buffer.alloc((0, Abi_1.encodeSingle)(type, value).length).fill(bitmask);
        if ((0, Abi_1.isDynamic)(type)) {
            if (bitmask) {
                throw 'Replacement is not supported for dynamic parameters.';
            }
            output.push(Buffer.alloc((0, Abi_1.encodeSingle)('uint256', dynamicOffset).length));
            data.push(cur);
            return offset + cur.length;
        }
        output.push(cur);
        return offset;
    }, dynamicOffset);
    var methodIdMask = Buffer.alloc(4);
    var mask = Buffer.concat([methodIdMask, Buffer.concat(output.concat(data))]);
    return encodeToBytes ? "0x".concat(mask.toString('hex')) : mask.map(function (b) { return (b ? 1 : 0); }).join('');
};
var encodeReplacementPattern = function (abi, replaceKind, encodeToBytes) {
    if (replaceKind === void 0) { replaceKind = types_1.FunctionInputKind.Replaceable; }
    if (encodeToBytes === void 0) { encodeToBytes = true; }
    return encodeReplacementPatterns(abi, [replaceKind], encodeToBytes);
};
exports.encodeReplacementPattern = encodeReplacementPattern;
var encodeCall = function (abi, parameters) {
    var inputTypes = abi.inputs.map(function (i) { return i.type; });
    var encodedFunc = (0, ethereumjs_util_1.bufferToHex)(Abi_1.ABI.methodID(abi.name, inputTypes));
    var encodedParams = tronweb_1.default.utils.abi.encodeParamsV2ByABI(abi, parameters);
    return encodedFunc + encodedParams.substring(2);
};
exports.encodeCall = encodeCall;
var encodeWeb3Call = function (abi, parameters) {
    return (0, exports.encodeCall)(abi, parameters);
};
exports.encodeWeb3Call = encodeWeb3Call;
var getParams = function (abi, _a) {
    var owner = _a.owner, replace = _a.replace;
    var parameters = abi.inputs.map(function (input) {
        switch (input.kind) {
            case types_1.FunctionInputKind.Replaceable:
                return replace;
            case types_1.FunctionInputKind.Owner:
                return owner;
            default:
                return input.value;
        }
    });
    return parameters;
};
exports.getParams = getParams;
var encodeParamsCall = function (abi, _a) {
    var owner = _a.owner, replace = _a.replace;
    var parameters = (0, exports.getParams)(abi, { owner: owner, replace: replace });
    var encodeCallData = (0, exports.encodeCall)(abi, parameters);
    return encodeCallData;
};
exports.encodeParamsCall = encodeParamsCall;
var encodeSell = function (schema, asset, address) {
    var transfer = schema.functions.transfer(asset);
    return {
        target: transfer.target,
        dataToCall: (0, exports.encodeDefaultCall)(transfer, address),
        replacementPattern: (0, exports.encodeReplacementPattern)(transfer)
    };
};
exports.encodeSell = encodeSell;
var encodeBuy = function (schema, asset, address, type) {
    var transfer = schema.functions.transfer(asset);
    var replaceable = transfer.inputs.filter(function (i) { return i.kind === types_1.FunctionInputKind.Replaceable; });
    var ownerInputs = transfer.inputs.filter(function (i) { return i.kind === types_1.FunctionInputKind.Owner; });
    // Validate
    if (replaceable.length !== 1) {
        failWith('Only 1 input can match transfer destination, but instead ' + replaceable.length + ' did');
    }
    // Compute call data
    var parameters = transfer.inputs.map(function (input) {
        switch (input.kind) {
            case types_1.FunctionInputKind.Replaceable:
                return address;
            case types_1.FunctionInputKind.Owner:
                return generateDefaultValue(input.type);
            default:
                return input.value.toString();
        }
    });
    var dataToCall = (0, exports.encodeCall)(transfer, parameters);
    // Compute replacement pattern
    var replacementPattern = '0x';
    if (ownerInputs.length > 0) {
        if (type === types_1.OfferType.ContractOffer) {
            replacementPattern = encodeReplacementPatterns(transfer, [types_1.FunctionInputKind.Owner, types_1.FunctionInputKind.Asset], true);
        }
        else {
            replacementPattern = (0, exports.encodeReplacementPattern)(transfer, types_1.FunctionInputKind.Owner);
        }
    }
    return {
        target: transfer.target,
        dataToCall: dataToCall,
        replacementPattern: replacementPattern
    };
};
exports.encodeBuy = encodeBuy;
var encodeDefaultCall = function (abi, address) {
    var parameters = abi.inputs.map(function (input) {
        switch (input.kind) {
            case types_1.FunctionInputKind.Replaceable:
                return generateDefaultValue(input.type);
            case types_1.FunctionInputKind.Owner:
                return address;
            case types_1.FunctionInputKind.Asset:
            case types_1.FunctionInputKind.Count:
            default:
                return input.value;
        }
    });
    return (0, exports.encodeCall)(abi, parameters);
};
exports.encodeDefaultCall = encodeDefaultCall;
